import React from 'react';

import { TemplatesProvider } from 'Templates';

import { withScreen, createScreenRoute, Screen } from '@gogame/screens';

import AnnotationsDataTable from './components/MainBudgetPlanningDataTable';
import {
  mainBudgetPlanningLink,
  mainBudgetPlanningSearchParams,
} from './navigation';
import screenReducer from './screenReducer';

const id = 1089;
const permission = 99;

const MainBudgetPlanning = withScreen({
  name: 'main-budget-planning',
  searchParams: mainBudgetPlanningSearchParams,
  reducer: screenReducer,
})(() => {
  return (
    <React.Fragment>
      <Screen.Toolbar />
      <Screen.Body>
        <AnnotationsDataTable />
      </Screen.Body>
    </React.Fragment>
  );
});

export default createScreenRoute({
  id: id,
  permission: permission,
  title: 'Main Budget Planning',
  link: mainBudgetPlanningLink,
  screen: (
    <TemplatesProvider serverPageId={id}>
      <MainBudgetPlanning />
    </TemplatesProvider>
  ),
});
